import { Component, OnInit, Input } from '@angular/core';
import { UserService } from 'src/app/services/user.service';
import { NuevaSolicitudDeRepuestosService } from '../nueva-solicitud-de-reppuestos/nueva-solicitud-de-repuestos.service';
import { ToastrService } from 'ngx-toastr';
import { AgregarRepuestoDialogServie } from '../agregar-repuesto-dialog/agregar-repuesto-dialog.service';
import { ConfirmService } from '../confirm/confirm.service';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-repuestos',
  templateUrl: './repuestos.component.html',
  styleUrls: ['./repuestos.component.css']
})
export class RepuestosComponent implements OnInit {

  constructor(private datePipe: DatePipe,private service: UserService, private nuevaSolicitudService: NuevaSolicitudDeRepuestosService, private confirm: ConfirmService ,private toast: ToastrService, private agregarRepuestoService: AgregarRepuestoDialogServie) { }

  repuestos_solicitados = [];
  tecnicos = [];

  @Input() tecnico_especifico;
  
  ngOnInit() {
  console.log(this.tecnico_especifico);
    
    this.service.getTecnicos().subscribe(d=>{
      this.tecnicos = d;
      this.getSolicitudes();
    })
    
  }

  getSolicitudes(){
    this.service.getSoliitudesRepuestos().subscribe(d=>{
      this.repuestos_solicitados = d.solicitudes;
      if(this.tecnico_especifico) this.repuestos_solicitados = this.repuestos_solicitados.filter(x=> x.tecnico_id == this.tecnico_especifico);
      this.repuestos_solicitados.forEach(x=> x.tecnico = this.tecnicos.find(t=> t._id == x.tecnico_id ) );
      this.repuestos_solicitados.forEach(x=> x.tecnico_label = x.tecnico?(x.tecnico.apellido + " " + x.tecnico.nombre + " " + x.tecnico.email):'ELIMINADO' );
      this.sort('fecha_alta');
    })
  }


  statusFilter = "ALL";
  filter = "";
  sortState ={};
  sort(column){
    this.sortState[column] = !this.sortState[column];
    this.repuestos_solicitados = this.repuestos_solicitados.sort( (a,b) =>{
      return  (a[column] > b[column] )? (this.sortState[column]?1:-1) :(this.sortState[column]?-1:1);
    })
  }

  getStep(status){
    switch(status){
      case "PENDIENTE": return 2;
      case "CANCELADO": return -1;
      case "EN CAMINO": return 3;
      case "RECIBIDO": return 4;
    }
  }


  setEnCamino(solicitud){
    this.confirm.confirm("Confimrar envío de repuestos", "¿Confirma el envío de repuestos?", "Confirmar", "Cancelar").then(confirmed=>{
      if(!confirmed) return;
      this.service.setEnCamino(solicitud).subscribe(d=>{
        this.repuestos_solicitados.find(x=> x._id == solicitud._id).status = "EN CAMINO";
      })
    })
   
  }



  nuevaSolicitud(){
    this.nuevaSolicitudService.agregar([],"Nueva solicitud", "Agrega repuestos a enviarle al técnico seleccionado", "Confirmar", "Cancelar").then( res =>{

    });
  }



  agregarRepuesto(solicitud){
    console.log(solicitud);
    
    this.agregarRepuestoService.agregar(solicitud.repuestos_solicitados,"Agregar repuesto", "Agregar repuestos", "OK", "CANCELAR", 'lg').then( nuevos =>{
      console.log(nuevos);
      this.service.agregarRepuestosASolicitud(solicitud._id, nuevos).subscribe(d=>{
        this.getSolicitudes();
      }, er=>{
        console.log(er);
        this.toast.error("ERROR");
        
      })
      
    });
  }


  cancelarPedidoRepuestos(solicitud){
    this.confirm.confirm("Cancelar solicitud", "¿Está seguro que desea cancelar la solicitud de repuestos?", "Aceptar", "Cancelar").then(confirmed =>{
      if(!confirmed) return;
      this.service.cancelarSolicitudRepuestos(solicitud._id).subscribe(d=>{
        this.toast.success("Solicitud cancelada");
        this.getSolicitudes();
      }, er=>{
        this.toast.error("ERROR");
      })
    })
  }


  getCsv(){
    this.service.getSolicitudRepuestosCsv(this.desde, this.hasta).subscribe(d=>{
      this.createCsv(d);
    }, er=>{
      if(er.status!=200){
        this.toast.error(er.error);
      }
      else this.createCsv(er.error.text);
    })
  }

  createCsv(content){
    var element = document.createElement('a');
      element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(content));
      element.setAttribute('download', "Solicitud_Repuestos.csv");
  
      element.style.display = 'none';
      document.body.appendChild(element);
      element.click();
      document.body.removeChild(element);
  }


  reenviarMailPedido(id){
    if(confirm("Reenviar email?")){
      this.service.reenviarMailPedido(id).subscribe(d=>{
        this.toast.success("Mail enviado");
      }, er=>{
        this.toast.error("error");
      })  
    }
    
  }



  showExportar = false;
  desde = this.datePipe.transform(new Date(), 'yyyy-MM-dd');
  hasta = this.datePipe.transform(new Date(), 'yyyy-MM-dd');
}
